export function getMessageFromError(error: unknown): string {
  if (isObject(error)) {
    if ('response' in error && isObject(error.response)) {
      if (error.response && 'data' in error.response && isObject(error.response.data)) {
        if (error.response.data && 'message' in error.response.data) {
          return String(error.response.data.message)
        }
      }
    }

    if ('message' in error) {
      return String(error.message)
    }
  }

  return ''
}

function isObject(val: unknown): val is Record<string, unknown> {
  return typeof val === 'object' && val !== null && !Array.isArray(val)
}
